export const SELECT_ALL_ITEMS_LENGTH_LIMIT = 200;

export const DESELECT_ALL_DISABLED_TOOLTIP = "Deselect all is not available when list exceeds 1000 items.";
